import React, { useContext } from 'react';
import { TableContext } from '../../../../../contexts/TableContext';
import { RowClassName } from '../../../../../enums';

interface PermissionMetricsRowProps {
  item: {
    module: string;
    role: string;
    [key: string]: any;
  };
  className?: RowClassName;
  actions?: string[];
}

const PermissionMetricsRow: React.FC<PermissionMetricsRowProps> = ({ item, className, actions = [] }) => {
  const { headCells } = useContext(TableContext);

  const renderValue = (value: boolean | string) => {
    if (value === true) {
      return <i className="ri-check-line text-success ri-20px" />;
    } else if (value === false) {
      return <i className="ri-close-line text-danger ri-20px" />;
    } else {
      return <span className="text-muted">-</span>;
    }
  };

  return (
    <tr className={className}>
      {headCells.map((headCell) => {
        if (headCell.id === 'role') {
          return (
            <td key={headCell.id} style={{ width: headCell.width }}>
              {item.role}
            </td>
          );
        }
        if (actions.includes(headCell.id)) {
          return (
            <td key={headCell.id} style={{ width: headCell.width }}>
              {renderValue(item[headCell.id])}
            </td>
          );
        }
        return null;
      })}
    </tr>
  );
};

export default PermissionMetricsRow;

